angular
  .module("ATMGCheckout", [])
  .controller("CheckoutController", CheckoutController)
  
CheckoutController.$inject = [
  "ATMGConf",
  "ApiCustomer",
  "$scope",
  "AddressBook",
  "User",
  "Api.Shipping",
  "$stateParams",
  "ErrorService",
  "Cart",
  "Checkout"
]
  
function CheckoutController(Config, Customer, $scope, AddressBook, User, Shipping, $stateParams, Errors, Cart, Checkout) {
    
    var _this = this;
    
    this.User           = User.getUserData(); // User + Cart
    this.AddressBook    = AddressBook; // AddressBook interface
    this.Shipping       = Shipping; // Shipping Interface
    this.Errors         = Errors; // Errors Service
    this.Checkout       = Checkout;
    this.Cart           = Cart;
    
    // Handle cart initialization
    if ($stateParams.cartId) {
      this.Cart.init($stateParams.cartId)
      .then(function() {
        return Checkout.init(this.Cart);
      }.bind(this));
    } else {
      this.Cart.resetOrders();
      this.Cart.init()
      .then(function() {
        return Checkout.init(this.Cart)
        .then(function() {
          if (!this.User) return;
          if (this.User.availablePaymentMethods.indexOf('NetTerms') > -1) {
            this.Checkout.payment.payment_terms = 'NetTerms';
          }
        }.bind(this))
      }.bind(this));
    }
    
    // link templates refs
    this.templates = Config.templates;
    
    this.addCustomerNote = function(line_item) {
      Cart.getCustomerNote(line_item.line_id)
        .then(response => {
          $scope.$emit('modal.open', {
            title: "Tell us what the problem is",
            template: 'customer_notes',
            data: {
              message: "This would be where you add stuff",
              line_item: line_item,
              note: response.data || ''
            }
          })
        })
    }
    
    /**------------------------------------------------------
    *
    *   creditCard Types
    *
    -----------------------------------------------------------*/
    this.cardTypes = [{
      name: "VISA",
      label: "Visa",
      mask: "9999 9999 9999 9999"
    }, {
      name: "AMEX",
      label: "American Express",
      mask: "9999 999999 99999"
    }, {
      name: "MC",
      label: "Mastercard",
      mask: "9999 9999 9999 9999"
    }];
    
    /**----------------------------------------------------------
    *
    *  Credit Card date Validation
    *
    ----------------------------------------------------------*/
    
    $scope.$watch(function() { return Checkout.payment }, function(nv, ov) {
      return Checkout.validateCard(nv, ov)
    }, true)
    
    /**----------------------------------------------------------
    *
    *  Add Address/Contact/Drop Ship
    *
    ----------------------------------------------------------*/
    this.contact = {}
}


// WEBPACK FOOTER //
// ./src/app/modules/ATMGCheckout/ATMGCheckout.js